class BrowserDetect {
    constructor() {
        this.browser = this.searchString() || 'An unknown browser'
        this.version = (
            this.searchVersion(navigator.userAgent) ||
            this.searchVersion(navigator.appVersion) ||
            0
        )
    }

    searchString() {
        for (const browser of this.browserData) {
            this.versionSearchString = browser.versionSearch || browser.identity

            if (browser.string) {
                if (browser.string.indexOf(browser.subString) !== -1) {
                    return browser.identity
                }
            } else if (browser.prop) {
                return browser.identity
            }
        }

        return null
    }

    searchVersion(dataString) {
        const index = dataString.indexOf(this.versionSearchString)

        if (index === -1) {
            return 0
        }

        return parseFloat(dataString.slice(index + this.versionSearchString.length + 1))
    }

    browserData = [
        {
            string: navigator.userAgent,
            subString: 'Chrome',
            identity: 'Chrome',
        },
        {
            string: navigator.userAgent,
            subString: 'CriOS',
            identity: 'Chrome',
            versionSearch: 'CriOS',
        },
        {
            string: navigator.vendor,
            subString: 'Apple',
            identity: 'Safari',
            versionSearch: 'Version',
        },
        {
            prop: window.opera,
            identity: 'Opera',
            versionSearch: 'Version',
        },
        {
            string: navigator.userAgent,
            subString: 'Firefox',
            identity: 'Firefox',
        },
        {
            string: navigator.userAgent,
            subString: 'MSIE',
            identity: 'IE',
            versionSearch: 'MSIE',
        },
    ]
}

const bd = new BrowserDetect()

const supportedVersions = [
    { browser: 'Chrome', minVersion: 43 },
    { browser: 'Safari', minVersion: 5 },
    { browser: 'Firefox', minVersion: 37 },
]

export default supportedVersions.some((browser) => (
    bd.browser === browser.browser && bd.version >= browser.minVersion
))



// WEBPACK FOOTER //
// ./app/browserDetection.js